<template>
  <div class="nav-container">
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
      <div class="container-fluid px-2 px-md-4">

        <a class="navbar-brand d-flex align-items-center" href="#">
          <img src="../assets/favicon.png" height="30" class="d-inline-block align-top mr-2" alt="Logo">
          <span class="brand-text">Agent Portal</span>
        </a>

        <div class="mobile-user-info d-lg-none ml-auto mr-3">
          <span class="mobile-user-text">
            Hi, <strong>{{ currentUserName }}</strong>
          </span>
        </div>

        <button 
          class="navbar-toggler border-0" 
          type="button" 
          @click="toggleMenu"
          :class="{ 'collapsed': !isMenuOpen }"
          aria-label="Toggle navigation"
        >
          <span class="toggler-icon top-bar"></span>
          <span class="toggler-icon middle-bar"></span>
          <span class="toggler-icon bottom-bar"></span>
        </button>

        <div class="collapse navbar-collapse" :class="{ 'show': isMenuOpen }" id="navbarSupportedContent">
          
          <ul class="navbar-nav mr-auto align-items-lg-center">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name:'posts'}" @click.native="closeMenu">Refill Product</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name:'dueClear' }" @click.native="closeMenu">Clear Dues</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name:'userList'}" @click.native="closeMenu">User List</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name:'ComplainStatus'}" @click.native="closeMenu">Complain Status</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name:'impactData'}" @click.native="closeMenu">Impact Data</router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" :to="{ name:'attendance'}" @click.native="closeMenu">Attendance</router-link>
            </li>
          </ul>

          <ul class="navbar-nav ml-auto align-items-lg-center">
            
            <li class="nav-item mr-3 d-none d-lg-block">
              <span class="welcome-text">
                Welcome, <strong>{{ currentUserName }}</strong>
              </span>
            </li>

            <li class="nav-item">
              <div class="btn-container">
                <a @click="logout" class="btn btn-logout shadow-sm">Logout</a>
              </div>
            </li>
          </ul>

        </div> 
      </div>
    </nav>
    
    <transition name="fade">
      <div v-if="isMenuOpen" class="menu-backdrop" @click="closeMenu"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isMenuOpen: false,
      isDropdownOpen: false
    };
  },
  computed: {
  currentUserName() {
    const fullName = this.$store.state.userName || 'Agent';
    
    // 2. Trim whitespace and split by spaces
    const nameParts = fullName.trim().split(' ');
    
    // 3. Return the last word
    return nameParts.length > 0 ? nameParts.pop() : 'Agent';
  }
},
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.isDropdownOpen = false;
    },
    logout() {
      this.$store.dispatch('logoutUser');
    }
  }
}
</script>

<style scoped>
/* --- 1. USERNAME STYLING --- */

/* Mobile Version */
.mobile-user-text {
  font-size: 0.9rem;
  color: #555;
  background-color: #f8f9fa;
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #e9ecef;
}
.mobile-user-text strong {
  color: #90288b; /* Brand Color */
}

/* Desktop Version */
.welcome-text {
  color: #666;
  font-size: 0.95rem;
}
.welcome-text strong {
  color: #90288b;
}

/* --- BASE STYLES --- */
.nav-container {
  position: relative;
  z-index: 1000;
}
.navbar {
  background-color: #ffffff;
  box-shadow: 0 2px 15px rgba(0,0,0,0.05);
  padding: 0.8rem 0; /* Adjusted padding for better fit */
}
.brand-text {
  font-weight: 700;
  font-size: 1.2rem;
  color: #333;
}
.nav-link {
  color: #555 !important;
  font-weight: 500;
  margin-right: 15px;
  transition: color 0.3s ease;
}
.nav-link:hover, .nav-link.router-link-exact-active {
  color: #007bff !important;
}

/* --- BUTTONS --- */
.btn-logout {
  background-color: #ff4757;
  color: white;
  border-radius: 20px;
  padding: 5px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
}
.btn-logout:hover {
  background-color: #ff6b81;
  transform: translateY(-1px);
}

/* --- ANIMATED HAMBURGER ICON --- */
.navbar-toggler {
  width: 30px;
  height: 25px;
  position: relative;
  padding: 0;
  outline: none !important;
}
.toggler-icon {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #333;
  border-radius: 3px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: .25s ease-in-out;
}
.top-bar { top: 0px; }
.middle-bar { top: 10px; }
.bottom-bar { top: 20px; }

/* Hamburger Animation State */
.navbar-toggler:not(.collapsed) .top-bar {
  top: 10px;
  transform: rotate(135deg);
}
.navbar-toggler:not(.collapsed) .middle-bar {
  opacity: 0;
  left: -60px;
}
.navbar-toggler:not(.collapsed) .bottom-bar {
  top: 10px;
  transform: rotate(-135deg);
}

/* --- MOBILE ANIMATIONS & LAYOUT --- */
@media (max-width: 991px) {
  
  /* 1. Reset Bootstrap Display Logic */
  .navbar-collapse {
    display: block !important; /* Override 'display: none' */
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    padding: 20px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
    border-top: 1px solid #f1f1f1;
    z-index: 9999;
    
    /* 2. THE ANIMATION PROPERTIES */
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px) scale(0.98); 
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55); 
    pointer-events: none; 
  }

  /* 3. THE ACTIVE STATE */
  .navbar-collapse.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0) scale(1);
    pointer-events: auto;
  }

  .nav-item {
    padding: 10px 0;
    border-bottom: 1px solid #f8f9fa;
  }
  
  /* Dropdown inside Mobile */
  .dropdown-menu {
    display: block; /* Override bootstrap */
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    padding: 0;
    border: none;
    transition: all 0.3s ease;
    background: #fafafa; 
  }
  
  .dropdown-menu.show {
    opacity: 1;
    max-height: 300px; 
    padding: 10px 0;
    margin-top: 5px;
  }
}

/* --- DESKTOP DROPDOWN ANIMATION --- */
@media (min-width: 992px) {
  .dropdown-menu {
    display: block;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.2s ease;
    margin-top: 10px;
  }
  .dropdown-menu.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

/* --- BACKDROP TRANSITION --- */
.menu-backdrop {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0,0,0,0.3);
  z-index: 998;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>